import { useState, useEffect } from 'react';
import Header from './components/Header';
import EventExpertise from './components/EventExpertise';
import PerformanceFormats from './components/PerformanceFormats';
import WhyMentalism from './components/WhyMentalism';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ContactPopup from '../../components/feature/ContactPopup';

export default function CorporatePage() {
  const [scrolled, setScrolled] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className={`transition-colors duration-300 ${scrolled ? 'text-black' : 'text-white'}`}>
                THOMAS
              </span>
            </div>
            
            <div className="hidden md:flex items-center gap-8">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className={`text-sm font-medium transition-colors duration-300 hover:text-red-600 cursor-pointer ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                Home
              </button>
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/college-university')}
                className={`text-sm font-medium transition-colors duration-300 hover:text-red-600 cursor-pointer ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                College &amp; University
              </button>
              <button 
                onClick={openPopup}
                className={`text-sm font-medium transition-colors duration-300 hover:text-red-600 cursor-pointer ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                About
              </button>
              <button 
                onClick={openPopup}
                className={`text-sm font-medium transition-colors duration-300 hover:text-red-600 cursor-pointer ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                Contact
              </button>
            </div>

            <button 
              onClick={openPopup}
              className="px-6 py-2.5 bg-red-600 text-white text-sm font-semibold rounded-full hover:bg-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-600/50 whitespace-nowrap cursor-pointer"
            >
              Request Consultation
            </button>
          </div>
        </div>
      </nav>

      <Header onConsultClick={openPopup} />
      <EventExpertise />
      <PerformanceFormats onConsultClick={openPopup} />
      <WhyMentalism />
      <Testimonials />
      <Gallery />
      <CTA onConsultClick={openPopup} />
      <Footer onLinkClick={openPopup} />

      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
}